<div
  class="modal-overlay"
  [class.active]="isWrapperTransactionActive && (txTrackingSvc.txModalActive$ | async)"
  [class.transaction]="isWrapperTransactionActive && (txTrackingSvc.txModalActive$ | async)">

  <div class="modal">
    <ng-container *ngIf="isWrapperTransactionActive && (txTrackingSvc.txModalActive$ | async)">
      <button class="close-modal" (click)="closeTransactionModal()">x</button>

      <ng-container *ngFor="let status of txTrackingSvc.txStatusArray; let i = index">
        <ng-container *ngIf="status.active">
          <h3>
            <img
              src="/assets/loader-{{ themeSvc.theme$ | async }}.gif"
              width="20"
              height="20"
              *ngIf="i === 0 || i === 1"
              alt=""
            />
            {{ status.title }}
          </h3>

          <span class="p-wrapper" [innerHTML]="status.message || ''"></span>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>

<div class="wrapper-panel">
  <div class="panel-header">
    <h2 class="section-title">Wrap / Unwrap</h2>
    <p class="section-subtitle">Manage your {{ environment.tokenName }} on the native or wrapped ERC-721 contract.</p>
  </div>

  <app-not-connected
    *ngIf="!(stateSvc.web3Connected$ | async)"
    description="Connect a wallet to wrap or unwrap the Punk V1 you own.">
  </app-not-connected>

  <ng-container *ngIf="stateSvc.web3Connected$ | async">
    <div class="loading-wrapper" *ngIf="loading">
      <app-loader></app-loader>
      <p>Loading your {{ environment.tokenName }}...</p>
    </div>

    <ng-container *ngIf="!loading && (owned | async) as data">
      <div class="empty-state" *ngIf="data.length === 0">
        <p>This wallet does not own any {{ environment.tokenName }}.</p>
      </div>

      <ng-container *ngIf="data.length > 0">
        <div class="summary-bar">
          <span class="summary-item">
            <strong>{{ ownedCount }}</strong> total
          </span>
          <span class="summary-item wrapped">
            <strong>{{ wrappedCount }}</strong> wrapped
          </span>
          <span class="summary-item unwrapped">
            <strong>{{ unwrappedCount }}</strong> native
          </span>
        </div>

        <div class="bulk-actions" *ngIf="wrappedCount > 0">
          <button
            class="action-btn bulk"
            (click)="unwrapAll()"
            [disabled]="isActionBusy">
            Unwrap All ({{ wrappedCount }})
          </button>
          <p class="hint">Uses the batch unwrap contract to return all wrapped punks to the native V1 market in one transaction.</p>
        </div>

        <p class="grid-label">Select a punk to wrap or unwrap individually:</p>

        <ul class="punk-grid">
          <li
            class="punk-item"
            *ngFor="let item of data; trackBy: trackByPunkId"
            [class.selected]="isSelected(item)"
            [class.wrapped]="item.wrapped"
            (click)="selectPunk(item)">

            <img
              [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (item.id | tokenIdParse) + '.svg'"
              [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
              width="50"
              height="50"
              [alt]="'Punk #' + item.id"
            />

            <span class="punk-id">#{{ item.id }}</span>

            <span
              *ngIf="!item.wrapped"
              class="listing-source unwrapped"
              title="Native V1">
              <ng-template [ngTemplateOutlet]="unwrappedLogo" />
            </span>

            <span
              *ngIf="item.wrapped"
              class="listing-source wrapped"
              title="Wrapped ERC-721">
              <ng-template [ngTemplateOutlet]="wrappedLogo" />
            </span>
          </li>
        </ul>

        <div class="selection-panel" *ngIf="current">
          <div class="selection-header">
            <span class="selection-title">Punk #{{ current.id }}</span>
            <span class="selection-badge" [class.wrapped]="current.wrapped">
              {{ current.wrapped ? 'Wrapped' : 'Native' }}
            </span>
          </div>

          <p class="warning" *ngIf="!current.wrapped && wrapStep === 'none'">
            Wrapping requires two transactions: first to allow the wrapper contract to access your punk, then to mint the ERC-721 wrapper token.
          </p>

          <div class="selection-actions">
            <button
              class="action-btn primary"
              (click)="triggerSingleAction()"
              [disabled]="isActionBusy">
              <ng-container *ngIf="!current.wrapped && wrapStep === 'none'">Initiate wrap (1/2)</ng-container>
              <ng-container *ngIf="!current.wrapped && wrapStep === 'sentToWrapContract'">Finalize wrap (2/2)</ng-container>
              <ng-container *ngIf="current.wrapped">Unwrap</ng-container>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #wrappedLogo>
  <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="-35.7142%" y1="100.0002%" x2="485.714%" y2="100.0002%" id="linearGradient-5bgi0umd9h-1"><stop stop-color="#AB05F2" offset="0%"></stop><stop stop-color="#654AF7" offset="100%"></stop></linearGradient></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M50,25 C50,38.8071 38.8071,50 25,50 C11.1929,50 0,38.8071 0,25 C0,11.1929 11.1929,0 25,0 C38.8071,0 50,11.1929 50,25 Z" id="Path" fill="url(#linearGradient-5bgi0umd9h-1)" fill-rule="nonzero"></path><path d="M35.0567,19.6862 C35.8411,19.6862 36.5471,19.7864 37.1749,19.9868 C37.3748,20.0506 37.5668,20.1246 37.7509,20.2087 C38.5128,20.5462 39.1007,21.036 39.5143,21.6782 C39.9279,22.3096 40.1348,23.0553 40.1348,23.9152 C40.1348,24.7752 39.9279,25.5208 39.5143,26.1522 C39.1007,26.7835 38.5128,27.2734 37.7509,27.6217 C37.5641,27.7044 37.3691,27.777 37.166,27.8394 C36.5404,28.0317 35.8373,28.1279 35.0567,28.1279 L33.0647,28.1279 L33.0647,31.1159 L29.8317,31.1159 L29.8317,19.6862 L35.0567,19.6862 Z M29.2512,17.0269 C29.4383,16.9862 29.6325,16.9648 29.8317,16.9648 L35.0567,16.9648 C36.3865,16.9648 37.6814,17.1878 38.8674,17.7269 C40.0599,18.258 41.0725,19.0756 41.7967,20.1961 C42.5354,21.3279 42.8561,22.6049 42.8561,23.9152 C42.8561,25.229 42.5336,26.5094 41.7906,27.6435 C41.0654,28.7505 40.058,29.5592 38.8823,30.0967 C38.8725,30.1012 38.8627,30.1056 38.8528,30.11 C37.8889,30.5368 36.8537,30.7591 35.786,30.8266 L35.786,31.1159 C35.786,32.6189 34.5676,33.8373 33.0647,33.8373 L29.8317,33.8373 C28.7678,33.8373 27.8465,33.2268 27.399,32.337 C26.9429,33.2462 26.0071,33.8373 24.9668,33.8373 L21.5052,33.8373 C20.596,33.8373 19.7672,33.3859 19.2682,32.666 C18.769,33.3864 17.9398,33.8373 17.0313,33.8373 L13.5697,33.8373 C12.3902,33.8373 11.3449,33.0774 10.9811,31.9554 L7.27458,20.5257 C7.00595,19.6973 7.14999,18.7904 7.66206,18.086 C8.17413,17.3816 8.99238,16.9648 9.86323,16.9648 L13.1942,16.9648 C14.1824,16.9648 15.0757,17.4981 15.5536,18.3298 C16.0319,17.4973 16.9257,16.9648 17.913,16.9648 L20.8847,16.9648 C21.8676,16.9648 22.7562,17.4922 23.236,18.3157 C23.7162,17.4916 24.6052,16.9648 25.5873,16.9648 L28.6733,16.9648 C28.8696,16.9648 29.0632,16.986 29.2512,17.0269 Z M19.3172,24.1601 L21.5052,31.1159 L24.9668,31.1159 L28.6733,19.6862 L25.5873,19.6862 L23.187,27.0502 L20.8847,19.6862 L17.913,19.6862 L15.4964,26.9849 L13.1942,19.6862 L9.86323,19.6862 L13.5697,31.1159 L17.0313,31.1159 L19.3172,24.1601 Z M33.0647,25.5807 L34.8608,25.5807 C34.9277,25.5807 34.9931,25.5792 35.0567,25.5764 C35.3306,25.564 35.5737,25.5249 35.786,25.4592 C35.9286,25.4151 36.0574,25.359 36.1722,25.2909 C36.2407,25.2502 36.3043,25.2053 36.363,25.1561 C36.7004,24.8622 36.8691,24.4486 36.8691,23.9152 C36.8691,23.3818 36.7004,22.9682 36.363,22.6743 C36.3005,22.6198 36.2323,22.5704 36.1586,22.5261 C36.0472,22.459 35.923,22.4035 35.786,22.3595 C35.5737,22.2913 35.3306,22.2507 35.0567,22.2379 C34.9931,22.2349 34.9277,22.2334 34.8608,22.2334 L33.0647,22.2334 L33.0647,25.5807 Z" id="Shape" fill="#FFFFFF"></path></g></svg>
</ng-template>

<ng-template #unwrappedLogo>
  <svg id="V1_08" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 210 178">
    <defs>
      <style>
        .st0 {
          fill: #fff;
          fill-rule: evenodd;
        }

        .st1 {
          fill: #a69afe;
        }
      </style>
    </defs>
    <rect class="st1" width="210" height="178" />
    <path id="v1" class="st0"
      d="M48,97h14v-44h-14v44ZM107,97h14v-44h-14v44ZM62,112h15v-15h-15v15ZM92,112h15v-15h-15v15ZM77,126h15v-14h-15v14ZM148,68h-15v15h15v43h14V53h-14v15Z" />
  </svg>
</ng-template>
